import React from 'react';

const MicrosoftLogo = ({ fill = "#9C9DA7" }) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_714_6862)">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 32H15.2231C15.2231 26.926 15.2231 21.8519 15.2231 16.7769H0V32Z" fill={fill} />
        <path fillRule="evenodd" clipRule="evenodd" d="M16.7769 32H31.9999C31.9999 26.926 31.9999 21.8519 31.999 16.7769C26.9259 16.7769 21.8518 16.7769 16.7778 16.7769C16.7759 21.851 16.7778 26.925 16.7778 32H16.7769Z" fill={fill} />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 15.2241C5.07403 15.2222 10.1481 15.2241 15.2231 15.2222C15.224 10.1482 15.2231 5.0751 15.2231 0.000114441H0V15.2241Z" fill={fill} />
        <path fillRule="evenodd" clipRule="evenodd" d="M16.7778 15.2223C21.8509 15.2242 26.9249 15.2223 31.9999 15.2223V-0.000754356H16.7769C16.7769 5.07328 16.7769 10.1473 16.7769 15.2213L16.7778 15.2223Z" fill={fill} />
      </g>
      <defs>
        <clipPath id="clip0_714_6862">
          <rect width="32" height="32" fill="white" transform="matrix(1 0 0 -1 0 32)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MicrosoftLogo;